// extracted by mini-css-extract-plugin
export default {"root":"YoutubeEmbed_root__6kwq3"};